export const getClassName = (name) => {
  return `resident_wrapper_${name}`;
};
